<template>
  <v-container v-once>
    <v-row class="mb-6" justify="center">
      <v-col class="text-center" cols="12" md="8">
        <v-icon
          :icon="mdiForum"
          class="mb-2"
          color="surface-variant"
          size="60"
        />

        <TitleParagraphBlock
          em-class-title="text-light-blue-darken-2 font-weight-medium"
          :value="value"
        />
      </v-col>
    </v-row>

    <v-row v-if="value.action && value.href">
      <v-col align="center">
        <v-btn
          :append-icon="mdiArrowRight"
          :href="value.href"
          :target="hrefTarget(value.href)"
          class="text-none"
          color="primary"
          exact
          rounded="pill"
          size="large"
          >{{ value.action }}</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { hrefTarget } from '#root/lib/utils'
import { mdiArrowRight, mdiForum } from '@mdi/js'

defineProps({
  value: {
    required: true,
    type: Object
  }
})
</script>
